<template>
    <SessionList class="mt-3" :userId="userId" @selectSession="onSelected" />
</template>

<script>
import SessionList from '@/components/SessionList';

export default {
    props: {
        userId: {type: String }
    },

    data() {
        return {
        };
    },

    methods: {
        onSelected(sessionId) {
            this.$router.push(`/recordings/${sessionId}`);
        }
    },

    components: {
        SessionList
    }
};
</script>